import { Component, h } from 'preact'
import ButtonControl from '../button-control'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import axios from 'axios'

interface Props {}

interface State {
  limit: number,
  current: number,
  isOpen: boolean
}

class SeatLimitWarningModal extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      limit: 0,
      current: 0,
      isOpen: true
    }
    this.closeModal = this.closeModal.bind(this)
  }
  closeModal () {
    this.setState({ isOpen: false })
  }

  async componentDidMount () {
    const response = await axios.get('/team/getSeatsSettings')
    const { limit, current } = response.data
    const isOpen = limit > 0 && current > limit
    this.setState({ limit, current, isOpen })
  }

  render (_: Props, { isOpen, limit, current }: State) {
    return (
      <Modal isOpen={isOpen && limit > 0 && current > limit} size='medium'>
        <ModalHeader title="You've exceeded your seat limit" onClose={this.closeModal} />
        <ModalBody>
            🎸 Great that your team is growing! By changing this user’s role, you went  over your current seat limit.
            That’s no problem - you can still continue.
            We'll reach out to discuss adjusting your limit, and won’t charge you anything without your consent.
        </ModalBody>
        <ModalFooter>
          <ButtonControl title='Okay, got it' onClick={() => this.closeModal()} variant='primary' />
          <button style={{ 'display': 'none' }} />
          <ButtonControl title='Review your seat usage' onClick={() => window.open('/team', '_blank')} />
        </ModalFooter>
      </Modal>
    )
  }
}

export default SeatLimitWarningModal
